import { render, staticRenderFns } from "./VehiclePlate.vue?vue&type=template&id=224c5967"
import script from "./VehiclePlate.vue?vue&type=script&lang=js"
export * from "./VehiclePlate.vue?vue&type=script&lang=js"
import style0 from "./VehiclePlate.vue?vue&type=style&index=0&id=224c5967&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports